import PropTypes from "prop-types";
import {
  Box,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@material-ui/core";
import CreateIcon from "@material-ui/icons/Create";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import StoreIcon from "@material-ui/icons/Store";
import { Link as RouterLink } from "react-router-dom";

export default function NoProducts({ groupPadding = 3 }) {
  return (
    <Box p={groupPadding}>
      <Typography variant="h5" color="textSecondary">
        😅 It&apos;s a bit empty in here...
      </Typography>
      <br />
      <Typography variant="body1" color="textSecondary">
        Here are some ideas to get you started:
      </Typography>

      <List>
        <ListItem>
          <ListItemIcon>
            <CreateIcon />
          </ListItemIcon>
          <ListItemText>
            Looking for a unique and personalized experience? Check out our{" "}
            <Link
              component={RouterLink}
              to={`/products?${new URLSearchParams({
                st: "Livestream Signing,Sign Anytime",
              })}`}
              onClick={() => {
                document.dispatchEvent(new Event("cart:close"));
              }}
            >
              Signed on Livestream and Signed with Video products.
            </Link>
          </ListItemText>
        </ListItem>

        <ListItem>
          <ListItemIcon>
            <LocalShippingIcon />
          </ListItemIcon>

          <ListItemText>
            Need a print by a certain date? We have Pre-Signed products that
            ship <em>fast</em>! Check them out on our{" "}
            <Link
              component={RouterLink}
              to={`/products?${new URLSearchParams({ st: "Presigned" })}`}
              onClick={() => {
                document.dispatchEvent(new Event("cart:close"));
              }}
            >
              Pre-Signed products page.
            </Link>
          </ListItemText>
        </ListItem>

        <ListItem>
          <ListItemIcon>
            <StoreIcon />
          </ListItemIcon>

          <ListItemText>
            Looking for frames or other accessories?{" "}
            <Link
              component={RouterLink}
              to="/streamilyaccessories"
              onClick={() => {
                document.dispatchEvent(new Event("cart:close"));
              }}
            >
              Visit our accessories store.
            </Link>
          </ListItemText>
        </ListItem>

        <ListItem>
          <ListItemIcon>
            <QuestionAnswerIcon />
          </ListItemIcon>

          <ListItemText>
            Questions about the fulfillment timeline? Take a look at{" "}
            <Link
              href="https://help.streamily.com/category/5-order-process"
              target="_blank"
              rel="noopener noreferrer"
            >
              our FAQs
            </Link>
          </ListItemText>
        </ListItem>
      </List>
    </Box>
  );
}

NoProducts.propTypes = {
  groupPadding: PropTypes.number,
};
